import { onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { auth, db } from "../firebase/client";

export function useFollowState(authorId: string | null): { isFollowing: boolean; uid: string | null } {
	const [uid, setUid] = useState<string | null>(null);
	const [isFollowing, setIsFollowing] = useState(false);

	useEffect(() => {
		return onAuthStateChanged(auth, (user) => {
			setUid(user && !user.isAnonymous ? user.uid : null);
		});
	}, []);

	useEffect(() => {
		if (!uid || !authorId || uid === authorId) {
			setIsFollowing(false);
			return;
		}

		return onSnapshot(
			doc(db, "users", uid, "following", authorId),
			(snap) => setIsFollowing(snap.exists()),
		);
	}, [uid, authorId]);

	return { isFollowing, uid };
}
